function getLayoutType() {

    var layout_type = 1200;

	if(window.matchMedia("only screen and (max-width: 480px)").matches) {
		var layout_type = 480;

	} else if(window.matchMedia("only screen and (max-width: 568px)").matches) {
		var layout_type = 568;

	} else if(window.matchMedia("only screen and (max-width: 768px)").matches) {
		var layout_type = 768;

	} else if(window.matchMedia("only screen and (max-width: 1024px)").matches) {
		var layout_type = 1024;

	} else {
		var layout_type = 1200;

	}

	return layout_type;
}

var collapsed_header_height = 235;

function goToSection() {

	var original_element_id = location.hash;

	var grid_width = getLayoutType();
	var element_id = original_element_id;//original_element_id.replace('section-', '');
	var section_offset_top = jQuery(element_id).offset().top;

	if(grid_width >= 1200 && !jQuery('body').hasClass('device-tablet') && !jQuery('body').hasClass('device-mobile') ) {// || isDesktop1024()
	  section_offset_top -= collapsed_header_height;
	}

	jQuery('body,html').animate({
		queue: false,
		scrollTop: section_offset_top
		}, 500, function() {
	});
}

function goToResponse() {

	var grid_width = getLayoutType();
	var section_offset_top = jQuery('.wpcf7-response-output').first().offset().top;

	if(grid_width >= 1200 && !jQuery('body').hasClass('device-tablet') && !jQuery('body').hasClass('device-mobile') ) {// || isDesktop1024()
	  section_offset_top -= collapsed_header_height;
	}

	jQuery('body,html').animate({
		queue: false,
		scrollTop: section_offset_top
		}, 500, function() {
	});
}

function handleCformEvents() {

    setTimeout(function(){
        var result_display = jQuery('.wpcf7-response-output');
        if(result_display.length > 0) {
            var first_result_display  = result_display.first();
            if(jQuery(first_result_display ).css('display') == 'block') {
                goToResponse();
                setTimeout(function(){
                    goToResponse();
                }, 800);
            }
        }    

    }, 200);
}
    
jQuery(function($){  
  $('.accordion').click(function() {
    var $this = $(this).toggleClass('active');
    var $panel = $this.next().toggleClass('show');
    $('.accordion.active').not(this).removeClass('active').next().removeClass('show');
  });
  
  if(location.hash != null && location.hash.length > 2 && location.hash.indexOf('section-') != -1) {
      goToSection();
      setTimeout(function(){
          goToSection();
      }, 800);			
  }
});

// Services: YouTube video modals
jQuery(function ($) {

    $('body').on('click', '[data-toggle="modal"][data-theVideo]', function () {
        var modalTarget = $(this).data('target');
        var videoURL = $(this).attr('data-theVideo');

        if (!modalTarget || !videoURL) return;

        $(modalTarget).find('iframe').attr('src', videoURL + (videoURL.indexOf('?') === -1 ? '?' : '&') + 'autoplay=1');
    });

    $('.modal[id^="videoModal"]').on('hidden.bs.modal', function () {
        $(this).find('iframe').attr('src', '');
    });

});

function isDesktop1024() {
    if(getLayoutType() == 1024 && !jQuery('body').hasClass('device-tablet') && !jQuery('body').hasClass('device-mobile')) {
      return true;
    } else {
      return false;
    }
}


jQuery(function ($) {
    $('#serviceAccordion').on('show.bs.collapse', '.panel-collapse', function () {
        $(this).prev('.panel-heading').find('.panel-title a').addClass('open');
    }).on('hide.bs.collapse', '.panel-collapse', function () {
        $(this).prev('.panel-heading').find('.panel-title a').removeClass('open');
    });
});


jQuery('#scroll-to-top a').bind('click', function(event) {
        event.preventDefault();
        
        jQuery('body,html').animate({
            queue: false,
            scrollTop: 0
            }, 300, function() {
        });
});
//